import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExchangeType } from '../models/exchange-type.model';
import { Role } from '../models/role.model';
import { BaseService } from './base.service';
import { WorkTray } from '../models/work-tray.model';
import { Currency } from '../models/order-currency.model';
import { ReleaseNotes } from '../models/relase-notes.model';
import { OrderCreateCurrencies } from '../models/order-create-currencies.model';
import { Office } from '../models/office.interface';
import { OrderTransactionTypes } from '../models/order-transaction-types.interface';
import { Producer } from '../models/producer.model';
import { ReferenceVirtualAccount } from '../models/account/reference-virtual-account.model';

@Injectable({
  providedIn: 'root',
})
export class ReferenceService extends BaseService {
  constructor(private http: HttpClient) {
    super(http);
   }

  getRoles(): Observable<Role[]> {
    return super.get<Role[]>('Reference/Roles');
  }

  getCustomerRoles(): Observable<Role[]> {
    return super.get<Role[]>('Reference/CustomerRoles');
  }

  getExchangeTypes(): Observable<ExchangeType[]> {
    return super.get<ExchangeType[]>('Reference/ExchangeTypes');
  }

  getTransactionTypes(): Observable<any[]> {
    return super.get<any[]>('Reference/Order/TransactionTypes');
  }

  getCompanyVirtualAccounts(): Observable<ReferenceVirtualAccount[]> {
    return super.get<ReferenceVirtualAccount[]>('Reference/Company/virtualAccounts');
  }

  getCompanyOffices(): Observable<Office[]> {
    return super.get<Office[]>('Reference/Company/offices');
  }

  getProductTypes(): Observable<any[]> {
    return super.get<any[]>('Reference/Product/Types');
  }

  getAccountCurrencies(): Observable<string[]> {
    return super.get<string[]>('Reference/account/currencies');
  }

  getModules(): Observable<string[]> {
    return super.get<string[]>('Reference/Modules');
  }

  getCompanyAccountCurrencies(): Observable<string[]> {
    return super.get<string[]>('Reference/CompanyAccount/currencies');
  }

  getWorkTray(): Observable<WorkTray[]> {
    return super.get<WorkTray[]>('Reference/WorkTray');
  }

  getOrderCurrency(): Observable<Currency[]> {
    return super.get<Currency[]>('Reference/CurrencyOrder');
  }

  getOrderCreateCurrency(): Observable<OrderCreateCurrencies> {
    return super.get<OrderCreateCurrencies>('Reference/CurrencyOrderV2');
  }

  getOrderTransactionTypes(): Observable<OrderTransactionTypes> {
    return super.get<OrderTransactionTypes>('Reference/CurrencyOrderV3');
  }

  getReleaseNotes(page: number) {
    const params = new HttpParams().set("page", page);
    return super.get<ReleaseNotes>(`Reference/ReleaseNotes`, params);
   }

  getProducerList(): Observable<Producer[]> {
    return super.get<Producer[]>('Producer/ProducerList');
  }

}
